import { SharedCallbacks } from "../shared-resources";

/**
 * Helper method for returning Group info
 * @returns Group information
 */
export function getGroupInfo() {
  const groupInfo =
    SharedCallbacks.getGroupInfo && SharedCallbacks.getGroupInfo();

  return groupInfo;
}

/**
 * Returns groups account code and their type if available and depending on their account type (BalanceAccount or MarketPlace), priority is for BalanceAccount if it exists.
 * Note that currently all POS clients should have an account code
 *
 */
export function getGroupAccountCodeAndType() {
  const groupInfo = getGroupInfo();
  if (!groupInfo) return { accountCode: null, accountType: "MarketPlace" };

  // start with new balance account code if it exists
  const newAccount =
    groupInfo.adyenAccountHolderNewList?.[0]?.adyenBalanceAccount?.[0]
      ?.balanceAccountId;
  if (newAccount)
    return { accountCode: newAccount, accountType: "BalanceAccount" };

  // otherwise get marketplace account code
  const oldAccount =
    groupInfo.adyenAccountHolderList?.[0]?.adyenAccountList?.[0]?.accountCode;
  if (oldAccount)
    return { accountCode: oldAccount, accountType: "MarketPlace" };

  return { accountCode: null, accountType: "MarketPlace" };
}
